/** Simple page router. */

export function switchPage(pageName: string): void {
  document.querySelectorAll(".page").forEach((el) => el.classList.remove("active-page"));
  document.querySelectorAll(".nav-btn").forEach((el) => el.classList.remove("active"));

  const page = document.getElementById(`${pageName}-page`);
  if (page) page.classList.add("active-page");

  const btn = document.querySelector(`.nav-btn[data-page="${pageName}"]`);
  if (btn) btn.classList.add("active");
}

export function initRouter(): void {
  document.querySelectorAll(".nav-btn").forEach((btn) => {
    btn.addEventListener("click", () => {
      const page = (btn as HTMLElement).dataset.page;
      if (page) switchPage(page);
    });
  });
}
